import { FilterObject } from "./Filter";
import { getAuthToken } from "../../functions/getAuthToken";
import { EC2Client } from "@aws-sdk/client-ec2";
import { fromWebToken } from "@aws-sdk/credential-providers";
import { getDefaultRoleAssumerWithWebIdentity } from "@aws-sdk/client-sts";
import { getInstanceTypes } from "../../functions/getInstanceTypes";
import { getSpotPrices } from "../../functions/getSpotPrices";

export const getSpotInstanceTableData = async (filter: FilterObject) => {
  const { Token, IdentityId } = await getAuthToken();

  const ec2Client = new EC2Client({
    region: "eu-west-1",
    credentials: fromWebToken({
      roleArn:
        "arn:aws:iam::573586820653:role/service-role/RegionPriceCompareAnonRole",
      webIdentityToken: Token,
      roleSessionName: IdentityId.substring(IdentityId.indexOf(":") + 1),
      roleAssumerWithWebIdentity: getDefaultRoleAssumerWithWebIdentity(),
    }),
  });

  const instanceTypesData = await getInstanceTypes(ec2Client, filter);

  const instanceTypes = instanceTypesData
    .map(({ InstanceType }) => InstanceType)
    .filter((instanceType) => instanceType !== undefined) as string[];

  const spotPriceData = await getSpotPrices(ec2Client, instanceTypes, filter);

  return instanceTypesData
    .filter(
      (instanceTypesData) =>
        spotPriceData[instanceTypesData.InstanceType!] !== undefined,
    )
    .map((instanceTypeData) => ({
      ...instanceTypeData,
      SpotInstancePrices: spotPriceData[instanceTypeData.InstanceType!],
    }));
};
